import React from 'react';

function SyncStatusIndicator({ syncStatus, onSyncClick }) {
  const { pendingCount, isSyncing, syncError } = syncStatus;

  // Only show indicator when there's something actionable to display
  if (isSyncing) {
    return (
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px 12px",
        background: "#dbeafe",
        border: "1px solid #3b82f6",
        borderRadius: "8px",
        fontSize: "13px",
        color: "#1e40af"
      }}>
        <div style={{
          width: "8px",
          height: "8px",
          background: "#3b82f6",
          borderRadius: "50%",
          animation: "pulse 1.5s ease-in-out infinite"
        }}></div>
        <span>Syncing...</span>
      </div>
    );
  }

  if (syncError) {
    return (
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px 12px",
        background: "#fef2f2",
        border: "1px solid #ef4444",
        borderRadius: "8px",
        fontSize: "13px",
        color: "#dc2626",
        cursor: "pointer"
      }} onClick={onSyncClick}>
        <div style={{ width: "8px", height: "8px", background: "#ef4444", borderRadius: "50%" }}></div>
        <span>Sync failed - tap to retry</span>
      </div>
    );
  }

  if (pendingCount > 0) {
    return (
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px 12px",
        background: "#f0f9ff",
        border: "1px solid #0ea5e9",
        borderRadius: "8px",
        fontSize: "13px",
        color: "#0c4a6e",
        cursor: "pointer"
      }} onClick={onSyncClick}>
        <div style={{
          width: "8px",
          height: "8px",
          background: "#0ea5e9",
          borderRadius: "50%",
          animation: "pulse 1.5s ease-in-out infinite"
        }}></div>
        <span>📊 {pendingCount} pending sync</span>
      </div>
    );
  }

  // Don't show any banner when online with no pending changes
  return null;
}

export default SyncStatusIndicator;